import Immutable from "immutable";
import RecordClassCreator, { ManyResourcePayload, SingleResourcePayload } from "services/record";

interface ResponseAttributes {
  buttonLabel?: Immutable.Map<string, unknown>;
  canAddMessages?: boolean;
  canBeQuickReply?: boolean;
  created?: string;
  description?: string;
  descriptiveString?: string;
  handle?: string;
  hasButtonLabel?: boolean;
  hasForcedQuickReplies?: boolean;
  hasTraining?: boolean;
  hasQuickReply?: boolean;
  live?: boolean;
  messages?: Immutable.Map<string, Immutable.Map<string, unknown>>;
  options?: Immutable.Map<string, Immutable.List<Immutable.Map<string, unknown>>>;
  tags?: Immutable.List<string>;
  reserved?: boolean;
  reservedResponseType?: string;
  reviewable?: boolean;
  updated?: string;
}

export default class Response extends RecordClassCreator<ResponseAttributes>({
  type: "response",
  buttonLabel: Immutable.Map(),
  canAddMessages: false,
  canBeQuickReply: false,
  created: null,
  description: "",
  descriptiveString: "",
  handle: "",
  hasButtonLabel: true,
  hasForcedQuickReplies: false,
  hasTraining: false,
  hasQuickReply: false,
  live: false,
  messages: Immutable.Map(),
  options: Immutable.Map(),
  tags: Immutable.List(),
  reserved: false,
  reservedResponseType: null,
  reviewable: false,
  updated: null
}) {
  // Getter not implemented. Add condition here to return Boolean.
  // If hasNewLabel is true, responses will have "NEW" label in response editor UI
  //
  // eslint-disable-next-line class-methods-use-this
  get hasNewLabel(): boolean {
    return false;
  }

  /**
   * @returns {String}
   */
  get isValid(): boolean {
    return Boolean(this.handle);
  }

  get languages(): Immutable.List<string> {
    return Immutable.List(this.messages.keys());
  }

  static getFetchManyUrl(): string {
    return "/responses/shallow";
  }

  static getFetchOneUrl(id: string): string {
    return `/responses/${id}`;
  }

  static resolveFetchOneResult(
    payload: {response: {_id: string; _type: string}}
  ): SingleResourcePayload {
    return {
      ...payload,
      data: {
        ...payload.response,
        reservedResponseType: payload.response._type
      }
    };
  }

  static resolveFetchManyResult(
    payload: { responses: {_id: string; _type: string}[] }
  ): ManyResourcePayload {
    return {
      ...payload,
      data: payload.responses.map(response => ({
        ...response,
        reservedResponseType: response._type
      }))
    };
  }
}
